import { IMessage, RoleType } from "../models/chat_models"


export const reverseSearchMessageForRole = (messages: Array<IMessage>, role: RoleType): IMessage | null => {
    let messageToReturn = null
    for(let i=messages.length -1;i>=0;i--){
        let messageRole = messages[i].role
        if(messageRole === 'user'){
            messageToReturn = messages[i]
            break
        }
    }

    return messageToReturn
}